import script from "./FormsApplication.vue?vue&type=script&setup=true&lang=js"
export * from "./FormsApplication.vue?vue&type=script&setup=true&lang=js"

import "./FormsApplication.vue?vue&type=style&index=0&id=ab795b48&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab795b48"]])

export default __exports__